import React from 'react';

import { useTranslation } from 'react-i18next';
import { CoreLink, RecursiveMenu } from '@uncinc/react-drupal-core';

import type { MenuItemLinkElementProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Image, Divider } from '../../../components';

import '../style.scss';

const FooterMenuItemWithImage = ({ item }: MenuItemLinkElementProps) => {
  const { link } = item;
  const title = link.title ?? 'Untitled';
  // MenuItemLinkElementProps options attributes is missing image
  // @ts-expect-error
  const image = link.options?.image?.styles.partner_slider_teaser ?? '';

  return (
    <div>
      <CoreLink href={link.url}>
        <Image
          src={image}
          alt={title}
        />
      </CoreLink>
    </div>
  );
};

const GenericFooter = () => {
  const { t } = useTranslation();
  return (
    <div id="Footer" className="Footer">
      <Container>
        <RecursiveMenu menuId="footer" />
      </Container>
      <Divider className="Footer__divider" />
      <Container>
        <div className="Footer__supportersMenu">
          <div className="Footer__supportersMenu__title">
            {t('footer_supported')}
          </div>
          <RecursiveMenu MenuItemLinkElement={FooterMenuItemWithImage} menuId="footer-supported-by" />
        </div>
      </Container>
      <Divider className="Footer__divider" />
      <Container>
        <div className="Footer__copyright">
          <div className="Footer__copyright__title">Copyright © {new Date().getFullYear()} Oranje Fonds</div>
          <RecursiveMenu menuId="footer-copyright" />
        </div>

      </Container>
    </div>
  );
};

export default GenericFooter;
